import React, { useCallback, useContext, useState } from "react";
import { classes } from "@bloomberg/media-ui-core";
import { useFortress } from "@foundation/fortress";
import { ViewportElement } from "@foundation/viewport-element";
import styles from "./financials.module.css";
import { QuoteContext } from "~context/QuoteContext";
import { getFortressState } from "~utils/getFortressState";
import { BarChartsPlaceholder } from "~components/BarCharts/BarChartsPlaceholder";
import { BarCharts } from "~components/dynamic";

export default function FinancialsContainer() {
  const quoteData = useContext(QuoteContext);
  const [enteredBarCharts, setEnteredBarCharts] = useState(false);
  const fortressContext = useFortress();
  const { isAllowed } = getFortressState(fortressContext);
  const [isDoneFetching, setIsDoneFetching] = useState(false);

  const onLoad = useCallback(() => setIsDoneFetching(true), []);

  if (!quoteData) {
    return null;
  }

  if (quoteData.type !== "EQT") {
    return null;
  }

  const { id } = quoteData;

  return (
    <ViewportElement
      onEnter={() => setEnteredBarCharts(true)}
      rootMargin={`400px`}
    >
      <div
        className={classes([
          styles.quotePageContainer,
          !isAllowed && styles.contentBlur,
        ])}
      >
        {!isDoneFetching && <BarChartsPlaceholder />}
        {enteredBarCharts && <BarCharts tickerId={id} onLoad={onLoad} />}
      </div>
    </ViewportElement>
  );
}
